module.exports = __webpack_public_path__ + "static/media/pic10.33259e11.jpg";